import * as React from 'react';
import { connect } from 'react-redux';

import { ColumnTextBlock } from '../../components/column_text_block/column_text_block';
import { ISeoData } from '../../models/seo_data';
import { IStore } from '../../models/store';

export interface ISeoBlockProps {
  isFetching: boolean;
  seoData: ISeoData;
}

const SeoBlock = (props: ISeoBlockProps) => {
  const seoData = props.seoData;

  return (
    <ColumnTextBlock
      columns={seoData.seoText}
      title={seoData.seoTextHeading}
    />
  );
};

const mapStateToProps = (state: IStore) => ({
  isFetching: state.mainpage.isFetching,
  seoData: state.mainpage.seoData,
});

export const SeoBlockContainer = connect<ISeoBlockProps, {}, {}>(mapStateToProps)(SeoBlock);
